
import { filter } from 'rxjs/operators';
import { Component, OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { WirePageBuilderService } from '../../services/wire-page-builder.service';
import { WireContactModel } from '../../models/wire-contact.model';
import { ContactDisplayElementModel } from '../../models/contact-display-element.model';
import { WireService } from '../../services/wire.service';
import { ImageUploadFieldModel } from '../../../../Common/PageBuilder/models/image-upload-field.model';
import { validateEmail } from '../../../../Common/Misc/helpers/formatting/email.helper';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-wire-contact-editor-dialog',
    templateUrl: './wire-contact-editor.component.html',
    styleUrls: ['./wire-contact-editor.component.scss'],
    standalone: false
})
export class WireContactEditorComponent extends AbstractDialogComponent implements OnDestroy {
    subscriptions: Subscription[] = [];
    name: string;
    email: string;
    title: string;
    contactImageUrl: string;
    primaryPhone: string;
    secondaryPhone: string;
    displayElement: ContactDisplayElementModel;

    nameError: boolean = false;
    emailError: boolean = false;
    emailFormatError: boolean = false;

    public imageUploadBlock = new ImageUploadFieldModel(
        null,
        'url',
        'Amplify.wire.contactEditor.image',
        '',
        1000000,
        'image/gif, image/jpeg, image/png, image/jpg',
        'Amplify.wire.contactEditor.upload',
        null,
        'Amplify.wire.contactEditor.image.tooltip'
    );

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        public wirePageBuilderService: WirePageBuilderService,
        public wireService: WireService
    ) {

        super(coreDialogService, 'WireContactEditor');

        this.subscriptions.push(
            this.wirePageBuilderService.getSelectedBlock().pipe(filter(x => !!x)).subscribe(block => {
                this.displayElement = (<ContactDisplayElementModel>block.displayElement);
                const contact = this.displayElement.contact;
                this.name = !!contact.name ? '' + contact.name : undefined;
                this.email = !!contact.email ? '' + contact.email : undefined;
                this.title = !!contact.title ? '' + contact.title : undefined;
                this.contactImageUrl = !!contact.contactImageUrl ? '' + contact.contactImageUrl : undefined;
                this.primaryPhone = !!contact.primaryPhone ? '' + contact.primaryPhone : undefined;
                this.secondaryPhone = !!contact.secondaryPhone ? '' + contact.secondaryPhone : undefined;
                this.imageUploadBlock.imageUploadState = !!this.contactImageUrl ? 'Amplify.wire.contactEditor.hasImage' : 'Amplify.wire.contactEditor.noImage';
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    updateContact(): void {
        this.displayElement.contact = new WireContactModel({
            name: this.name?.trim(),
            email: this.email?.trim(),
            title: this.title?.trim(),
            contactImageUrl: this.contactImageUrl?.trim(),
            primaryPhone: this.primaryPhone?.trim(),
            secondaryPhone: this.secondaryPhone?.trim(),
        } as WireContactModel);

        this.wireService.currentResourceModified();
        this.closeDialog();
    }

    validateContactName(): void {
        this.nameError = !this.name || !(this.name.trim().length > 0);
    }

    validateContactEmail(): void {
        this.emailError = !this.email || !(this.email.trim().length > 0);
        this.emailFormatError = !this.emailError && !validateEmail(this.email);
    }

    imageUploaded(url: string): void {
        this.contactImageUrl = url;
        this.imageUploadBlock.imageUploadState = !!this.contactImageUrl ? 'Amplify.wire.contactEditor.hasImage' : 'Amplify.wire.contactEditor.noImage';
    }
}
